import React from "react";

const steps = [
  {
    icon: "fa-brands fa-whatsapp",
    title: "WhatsApp/ Email Connect",
    desc: "Fill a simple form. We respond within minutes.",
    color: "from-green-500 to-emerald-500",
  },
  {
    icon: "fa-solid fa-comments",
    title: "Initial Guidance",
    desc: "Get a free foundational guidance tailored to your stage, industry and goal.",
    color: "from-blue-500 to-indigo-500",
  },
  {
    icon: "fa-solid fa-rocket",
    title: "Upgrade to Pro Engagements",
    desc: "Engage vetted experts when you're ready to go deep on a problem.",
    color: "from-orange-500 to-amber-500",
  },
  {
    icon: "fa-solid fa-arrow-trend-up",
    title: "Scale Your Business",
    desc: "Compound growth across funding, ops, hiring & GTM — together.",
    color: "from-fuchsia-500 to-purple-500",
  },
];

const HowItWorks = () => {
  return (
    <section
      id="how"
      className="py-20 sm:py-28 bg-white"
      data-testid="how-it-works-section"
    >
      <div className="section">
        <div className="text-center max-w-2xl mx-auto">
          <span className="chip mx-auto">
            <i className="fa-solid fa-route text-ibh-green"></i>
            How It Works
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-5xl font-bold text-slate-900 leading-tight">
            Simple, fast, <span className="gradient-text">founder-friendly</span>
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute left-[12%] right-[12%] top-12 h-px border-t border-dashed border-slate-300"></div>

          {steps.map((s, i) => (
            <div
              key={s.title}
              className="relative rounded-3xl bg-gradient-to-b from-white to-slate-50 border border-slate-200/70 p-6 card-hover"
              data-testid={`step-${i + 1}`}
            >
              <div className="flex items-center justify-between">
                <div
                  className={`relative h-14 w-14 rounded-2xl bg-gradient-to-br ${s.color} flex items-center justify-center text-white shadow-soft`}
                >
                  <i className={`${s.icon} text-xl`}></i>
                </div>
                <span className="font-display text-5xl font-bold text-slate-100 select-none">
                  0{i + 1}
                </span>
              </div>
              <p className="mt-5 font-display font-bold text-lg text-slate-900">
  {s.title}
</p>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
